import { Suspense, lazy } from "react";
import { Outlet } from "react-router-dom";
import DashboardLayout from "../layouts/dashboard";
import AuthGuard from "../guards/AuthGuard";
import RoleGuard from "../guards/RoleGuard";
import Loader from "@/components/Loader";
import { PATH_INBOX } from "./paths";

const InboxPage = lazy(() => import("@pages/inbox"));

/**
 * Omnichannel Inbox (IR-69): `/inbox` and `/inbox/:conversationId`, gated by inbox:access.
 */
const inboxRoutes = [
  {
    path: PATH_INBOX,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <RoleGuard>
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
          </RoleGuard>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <InboxPage />, index: true },
      { path: ":conversationId", element: <InboxPage /> },
    ],
  },
];

export default inboxRoutes;
